import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Row } from '@bootstrap-styled/v4';
import Col from '@bootstrap-styled/v4/lib/Col';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Media from 'shared-components/theme/medias';
import Video from 'shared-components/video/video';

// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

const BannerMorph = (props) => {
    const videoRef = useRef(null);
    const [dimensions, setDimensions] = useState({
        width: '100vw',
        height: 'calc(100vh - 82px)',
        borderRadius: '0%',
    });

    useEffect(() => {
        const element = videoRef.current;
        if (!element) return;

        // Set initial state explicitly
        const initialSize = '100.8vw';

        gsap.set(element, {
            width: props?.fromWidth || initialSize,
            height: props?.fromWidth || initialSize, // Same as width for square
            borderRadius: '0%',
        });

        // Create ScrollTrigger animation
        const finalSize = '50vw';

        const animation = gsap.to(element, {
            width: finalSize,
            height: finalSize,
            minWidth: finalSize,
            minHeight: finalSize,
            borderRadius: props?.radius || '50%',
            ease: 'power2.inOut',
            scrollTrigger: {
                trigger: element,
                start: 'top bottom',
                end: 'center center',
                scrub: 1,
                invalidateOnRefresh: true,
                refreshPriority: 1,
            },
        });

        return () => {
            animation.kill();
            ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
        };
    }, [props]);

    // Handle resize
    useEffect(() => {
        const handleResize = () => {
            ScrollTrigger.refresh();
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <Wrapper height={props?.toHeight}>
            <Row>
                <Col md="12">
                    <IntroVideo
                        ref={videoRef}
                        margin={props?.margin}
                        marginTop={props?.marginTop}
                        moboMargin={props?.moboMargin}>
                        <Video {...props} />
                    </IntroVideo>
                </Col>
            </Row>
        </Wrapper>
    );
};

const Wrapper = styled.div`
    height: ${(props) => props.height || '100vw'};
    min-height: ${(props) => props.height || '100vw'};
    position: relative;

    ${Media('xlscreens')} {
        height: ${(props) => props.height || '55vw'};
        min-height: ${(props) => props.height || '55vw'};
    }
    ${Media('mobile')} {
        height: ${(props) => props.height || '300px'};
        min-height: ${(props) => props.height || '300px'};
    }
`;

const IntroVideo = styled.div`
    width: calc(100vh - 82px);
    height: calc(100vh - 82px);
    min-width: calc(100vh - 82px); /* Ensure width doesn't collapse */
    min-height: calc(100vh - 82px);
    border-radius: 0%;
    overflow: hidden;
    margin: ${(props) => props?.margin || '60px auto 0'};
    will-change: transform, width, height, border-radius;
    transform: translateZ(0);
    aspect-ratio: 1 / 1;
    ${Media('xlscreens')} {
        width: 100vw;
        height: 100vw;
        min-width: 100vw;
        min-height: 100vw;
        margin: ${(props) => props?.margin || '5vw auto'};
    }

    ${Media('tablet')} {
        width: 100vw;
        height: 100vw;
        min-width: 100vw;
        min-height: 100vw;
        aspect-ratio: 1 / 1;
    }

    ${Media('mobile')} {
        width: 100vw;
        height: 100vw;
        min-width: 100vw;
        min-height: 100vw;
        margin-top: ${(props) => props?.moboMargin || 20}px;
    }

    ${Media('tabletlandscape')} {
        margin-top: ${(props) => props?.moboMargin}px;
    }
`;

export default BannerMorph;
